import { useState } from "react";
import { useTranslation } from "react-i18next";
import ControlInputBox from "@/components/Form/InputBox/ControlInputBox";
import ControlSelect from "@/components/Form/SelectBox/ControlSelect";
import { Control } from "react-hook-form";
import { MotifButton, MotifIcon, MotifInput } from "@/libs/@ey-xd/motif-react";
import { actionIcDelete24px } from "@ey-xd/motif-react/assets/icons";

export default function CustomDisplaySingleSelect({
    index,
    control,
    setValue,
}: {
    index: number;
    control: Control<any>;
    setValue: any;
}) {
    const { t } = useTranslation();
    const [selectOptions, setSelectOptions] = useState<any[]>([{ name: "", nameFrench: "" }]);

    const handleDefaultValueChange = (value: string) => {
        const updatedMetadata = JSON.stringify({
          Native: "false",
          default: value,
        });
      
        setValue(`fields[${index}].customAttributeDefinition.metadataJSON`, updatedMetadata);
      };
      
    const updateSelectOption = (value: string, idx: number, key: "name" | "nameFrench") => {
        let options = [...selectOptions];
        options[idx] = { ...options[idx], [key]: value, displayOrder: 0 };
        setSelectOptions(options);
        setValue(`fields[${index}].customAttributeDefinition.picklistDefinitions`, options);
    };

    return (
        <>
            <div className="motif-row">
                <div className="motif-col-lg-4">
                    <ControlInputBox
                        name={`fields.[${index}].displayName`}
                        control={control}
                        required={false}
                        isTextArea={false}
                        label={t("pages.portalConfig.labels.displayName")}
                        showLabel={true}
                    />
                </div>
                <div className="motif-col-lg-4">
                    <ControlInputBox
                        name={`fields.[${index}].displayNameFrench`}
                        control={control}
                        isTextArea={false}
                        label={t("pages.portalConfig.labels.displayNameFR")}
                        showLabel={true}
                    />
                </div>
            </div>
            <div className="motif-row">
                <div className="motif-col-lg-4">
                    <div className="form-field ">
                        <ControlInputBox
                            name={`fields.[${index}].tooltip`}
                            control={control}
                            required={false}
                            isTextArea={false}
                            label={t("pages.portalConfig.labels.tooltip")}
                            showLabel={true}
                        />
                    </div>
                </div>
                <div className="motif-col-lg-4">
                    <div className="form-field">
                        <ControlInputBox
                            name={`fields.[${index}].tooltipFrench`}
                            control={control}
                            isTextArea={false}
                            label={t("pages.portalConfig.labels.tooltipFR")}
                            showLabel={true}
                        />
                    </div>
                </div>
            </div>
            <div className="motif-row">
                <div className="motif-col-lg-4">
                    <ControlSelect
                        name={`fields.[${index}].defaultValue`}
                        control={control}
                        required={false}
                        label={t("pages.configuration.attributes.createAttribute.defaultOption")}
                        showLabel={true}
                        options={selectOptions.map((option, idx) => ({ value: option.name, label: option.name }))}
                        handleChange={handleDefaultValueChange}
                    />
                </div>
                <div className="motif-col-lg-4" style={{ display: 'flex', alignItems: 'end' }}>
                    <MotifButton
                        size="small"
                        variant="secondary"
                        onClick={() => setSelectOptions([...selectOptions, { value: "", label: "" }])}
                    >
                        {t("pages.configuration.attributes.createAttribute.addValue")}
                    </MotifButton>
                </div>
            </div>
            <div className="motif-row">
                {selectOptions.map((option, idx) => (
                    <div key={idx} className="motif-col-lg-9 motif-row" style={{ gap: "10px" }}>
                        <div className="motif-col-lg-4">
                            <MotifInput
                                control={control}
                                className="select-type-option"
                                onChange={(event) =>
                                    updateSelectOption(event.target.value, idx, "name")
                                }
                                value={option.name}
                                placeholder={t("pages.portalConfig.labels.optionName")}
                            />
                        </div>
                        <div className="motif-col-lg-4">
                            <MotifInput
                                control={control}
                                className="select-type-option"
                                onChange={(event) =>
                                    updateSelectOption(event.target.value, idx, "nameFrench")
                                }
                                value={option.nameFrench}
                                placeholder={t("pages.portalConfig.labels.optionNameFR")}
                            />
                        </div>
                        <div className="motif-col-lg-2">
                        {idx > 0 && (
                            <MotifButton
                                onClick={() => setSelectOptions(selectOptions.filter((_, i) => i !== idx))}
                                variant="primary-alt"
                            >
                                <MotifIcon iconFunction={actionIcDelete24px} size="24" />
                            </MotifButton>
                        )}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}
